import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Marketplace from "@/pages/Marketplace";
import LotDetail from "@/pages/LotDetail";
import HeritageDb from "@/pages/HeritageDb";
import ServiceDirectory from "@/pages/ServiceDirectory";
import ProviderProfile from "@/pages/ProviderProfile";
import SellerPortal from "@/pages/SellerPortal";
import BuyerPortal from "@/pages/BuyerPortal";
import OrderDetail from "@/pages/OrderDetail";
import AdminConsole from "@/pages/AdminConsole";
import ProfilePage from "@/pages/ProfilePage";
import Terms from "@/pages/Terms";
import { Toaster } from "sonner";
import "@/App.css";

function Protected({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-10 text-center text-stone-500">Loading…</div>;
  if (!user || user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role) && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/marketplace" element={<Marketplace />} />
        <Route path="/lots/:lotId" element={<LotDetail />} />
        <Route path="/heritage" element={<HeritageDb />} />
        <Route path="/directory" element={<ServiceDirectory />} />
        <Route path="/directory/me" element={<Protected roles={["service_provider"]}><ProviderProfile /></Protected>} />
        <Route path="/seller/*" element={<Protected roles={["seller"]}><SellerPortal /></Protected>} />
        <Route path="/buyer/*" element={<Protected roles={["buyer", "seller"]}><BuyerPortal /></Protected>} />
        <Route path="/orders/:orderId" element={<Protected><OrderDetail /></Protected>} />
        <Route path="/admin/*" element={<Protected roles={["admin"]}><AdminConsole /></Protected>} />
        <Route path="/profile" element={<Protected><ProfilePage /></Protected>} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LanguageProvider>
            <CurrencyProvider>
              <AppRouter />
              <Toaster richColors position="top-right" />
            </CurrencyProvider>
          </LanguageProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
